<!-- title -->
<app-modal-title
  [title]="formPageConfig.vocabs + 'legend' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content" style="max-width: 600px">
  <div class="row" *ngIf="isSuccessPurchase">
    <div class="tw-w-full">
      <div class="tw-flex flex-column tw-items-center">
        <i
          class="mdi mdi-48px text-success mdi-check-decagram tw-mt-[20px]"
        ></i>
        <p class="tw-font-semibold text-success tw-text-[18px] tw-mt-2">
          {{ "messages.successfulPurchase" | translate }}
        </p>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="isSuccessPurchase">
    <div class="tw-w-full">
      <p class="tw-text-gray-700 tw-pr-1 tw-mb-2 tw-text-[13px]">
        {{ formPageConfig.vocabs + "PlanModuleBought" | translate }}
      </p>
    </div>

    <!-- title -->
    <div class="sm:tw-w-1/2">
      <list-group-item
        paddingClass="tw-py-2"
        marginClass="tw-my-1"
        label="common.title"
        [value]="planTypeModule?.name"
      >
      </list-group-item>
    </div>

    <!-- expiration -->
    <div class="sm:tw-w-1/2">
      <list-group-item
        paddingClass="tw-py-2"
        marginClass="tw-my-1"
        label="common.expireDate"
        [isShowValue]="false"
      >
        <div
          class="tw-flex badge badge-light border tw-text-gray-800 tw-text-[13px] text-wrap dir-ltr"
          content
        >
          <span>{{
            planTypeModule?.expirationTime
              | dateTimeConvertor : translationService.currentLang()
          }}</span>
        </div>
      </list-group-item>
    </div>

    <!-- chargeRateCredit -->
    <div class="sm:tw-w-1/2">
      <list-group-item
        paddingClass="tw-py-2"
        marginClass="tw-my-1"
        label="common.price"
        [value]="planTypeModule?.price | numberSeparator"
      >
      </list-group-item>
    </div>

    <!-- discountAmount -->
    <div class="sm:tw-w-1/2" *ngIf="discountAmount">
      <list-group-item
        paddingClass="tw-py-2"
        marginClass="tw-my-1"
        label="common.discount"
        [value]="discountAmount | numberSeparator"
      >
      </list-group-item>
    </div>

    <!-- finalAmount -->
    <div class="sm:tw-w-1/2">
      <list-group-item
        paddingClass="tw-py-2"
        marginClass="tw-my-1"
        label="common.paymentAmount"
        [value]="finalAmount | numberSeparator"
      >
      </list-group-item>
    </div>

    <!-- close tab button -->
    <section
      *ngIf="isSuccessPurchase"
      class="tw-flex-center flex-column tw-mt-3"
    >
      <button
        (click)="onSuccess()"
        class="btn bg-gradient-blue tw-w-[175px] tw-my-2 text-white btn-hover-rise"
      >
        <span>{{ "common.close" | translate }}</span>
      </button>
    </section>
  </div>

  <div class="row" *ngIf="!isSuccessPurchase">
    <section class="tw-w-full">
      <form [formGroup]="form">
        <div class="tw-flex tw-justify-between tw-items-center flex-column">
          <div class="row tw-mt-[10px] tw-w-full">
            <!-- discountCode -->
            <div class="tw-w-full">
              <app-verify-discount-input
                class="tw-w-full"
                [discountPlace]="DiscountPlace.PlanModulePurchase"
                [id]="model.planId"
                (result)="getVerifyDiscountResult($event)"
              >
              </app-verify-discount-input>
            </div>
          </div>
        </div>
      </form>
    </section>

    <!-- summary -->
    <section class="md:tw-w-full tw-mt-2">
      <div class="tw-p-3 tw-p-5 rounded tw-w-full">
        <!-- credit -->
        <div class="tw-mt-2">
          <div
            class="tw-flex tw-justify-between tw-items-center border-bottom-dashed tw-pb-3 tw-mb-3"
          >
            <div class="tw-text-gray-700 tw-text-[12px]">
              {{ "common.organizationCredit" | translate }}
            </div>

            <!-- error -->
            <div class="tw-flex-center tw-mr-2">
              <div class="tw-relative">
                <div
                  class="tw-font-medium tw-text-[15px] dir-ltr"
                  [class]="
                    userCredit < finalAmount
                      ? 'text-danger'
                      : 'tw-text-gray-800'
                  "
                >
                  {{ userCredit | numberSeparator }}
                </div>
              </div>
              <!-- <small class="tw-text-[10px] tw-font-semibold tw-mr-[5px] ltr:tw-ml-[5px]"
                [class]="userCredit<finalAmount?'text-danger':'tw-text-gray-800'">{{"common.currency"|translate}}</small> -->
            </div>
          </div>

          <div
            class="tw-py-2 tw-pb-5 tw-font-medium tw-text-[12px] tw-flex-center flex-column"
            *ngIf="userCredit < finalAmount"
          >
            <span class="text-danger tw-text-[13px] tw-mt-2">
              {{ "messages.notEnoughCredit" | translate }}
            </span>
            <span
              class="btn btn-sm tw-mt-2"
              (click)="openIncreaseCredit()"
              [themeColor]="'btn'"
            >
              {{ "common.increaseCredit" | translate }}
            </span>
          </div>
        </div>

        <!-- price -->
        <div class="tw-mt-2">
          <div
            class="tw-flex tw-justify-between tw-items-center border-bottom-dashed tw-pb-3 tw-mb-3"
          >
            <div class="tw-text-gray-700 tw-text-[12px]">
              {{ "common.price" | translate }}
            </div>

            <div class="tw-flex-center tw-mr-2">
              <div class="tw-relative">
                <div class="tw-font-medium tw-text-[15px] tw-text-gray-800">
                  {{ planTypeModule?.price | numberSeparator }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- discount value -->
        <div class="tw-mt-2">
          <div
            class="tw-flex tw-justify-between tw-items-center border-bottom-dashed tw-pb-3 tw-mb-3"
          >
            <div class="tw-text-gray-700 tw-text-[12px]">
              {{ "common.discount" | translate }}
            </div>

            <div class="tw-flex-center tw-mr-2">
              <div class="tw-relative">
                <div
                  class="tw-font-medium tw-text-[15px]"
                  [class]="discountAmount ? 'text-success' : 'tw-text-gray-800'"
                >
                  {{ discountAmount | numberSeparator }}
                </div>
              </div>
              <!-- <small class="tw-text-[10px] tw-font-semibold tw-mr-[5px] ltr:tw-ml-[5px]  tw-text-gray-800"
                [class.text-success]="discountAmount">{{"common.currency"|translate}}</small> -->
            </div>
          </div>
        </div>

        <!-- final amount -->
        <div class="tw-flex tw-justify-between tw-items-center tw-mt-2">
          <div class="tw-text-gray-700 tw-text-[12px]">
            {{ "common.payable" | translate }}
          </div>

          <div class="tw-flex-center tw-mr-2">
            <div class="tw-relative">
              <div class="tw-font-semibold tw-text-[25px] text-primary">
                {{ finalAmount | numberSeparator }}
              </div>
            </div>
            <small
              class="tw-text-[14px] tw-font-semibold tw-mr-[5px] ltr:tw-ml-[5px] text-primary tw-mt-2"
              >{{ "common.currency" | translate }}</small
            >
          </div>
        </div>
      </div>
    </section>
  </div>

  <!-- submit button -->
  <section
    *ngIf="!isSuccessPurchase"
    class="tw-flex-center flex-column tw-mt-3"
  >
    <button
      (click)="onSubmit()"
      class="btn bg-gradient-blue tw-w-[175px] tw-my-2 text-white btn-hover-rise"
    >
      <span *ngIf="!loading">{{ "common.payment" | translate }}</span>

      <ng-container *ngIf="loading">
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        <span class="sr-only">Loading...</span>
      </ng-container>
    </button>
  </section>
</div>
